import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import WarningIcon from "@mui/icons-material/Warning";
import PeopleIcon from "@mui/icons-material/People";
import {
    Person,
    ProductionQuantityLimits,
    PropaneRounded,
    RoomSharp,
    ShoppingCart,
} from "@mui/icons-material";

const MenuRoutes = [
    {
        route: "/Users",
        text: "Users",
        icon: <Person />,
        allowedUsers: [1, 2],
    },

    {
        route: "/ItemList",
        text: "Items",
        icon: <CategoryIcon />,
        allowedUsers: [1, 2, 3],
    },
    {
        route: "/StockLocationList",
        text: "Stock Locations",
        icon: <RoomSharp />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2],
    },
    {
        route: "/SalesList",
        text: "Sales",
        icon: <ReceiptIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    {
        route: "/AddSale",
        text: "Create Sale",
        icon: <PointOfSaleIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    {
        route: "/AddBuyInvoice",
        text: "Add Buy Invoice",
        icon: <ShoppingCart />,
        allowedUsers: [1, 2],
    },
    {
        route: "/BuyInvoices",
        text: "Buy Invoices",
        icon: <PropaneRounded />,
        allowedUsers: [1, 2],
    },

    {
        route: "/CustomerList",
        text: "Other Parties",
        icon: <GroupIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    // New menu items for reports
    {
        route: "/customer-reports",
        text: "Customer Reports",
        icon: <PeopleIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    {
        route: "/unpaid-invoices",
        text: "Unpaid Invoices",
        icon: <WarningIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    // End of new menu items
    {
        route: "/Expenses",
        text: "Expenses",
        icon: <AddBusinessIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    {
        route: "/items-below-min-quantity",
        text: "Items Below Min Quantity",
        icon: <ProductionQuantityLimits />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
    {
        route: "/items-expiring-soon",
        text: "Items Expiring Soon",
        icon: <WarningIcon />,
        isEnableForEmployee: true,
        allowedUsers: [1, 2, 3],
    },
];
export default MenuRoutes;
